import React from 'react';
import FeeCollection from './FeeCollection';
import '../../../CommonCSS/SocietyCSS.css'

const FeeCollectionApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Fees Collection</h5>
          </div>
        </div>
        <FeeCollection/>
      </div>
    </div >
  );
};

export default FeeCollectionApp;
